import CookieUtil from "../storage/cookieUtil";
import { requestDesktopFeed, requestMobileStoreFeed } from "../../store/slices/dynamicHomeSlice";

/**
 * Refreshes the home page feed after a location-gate change.
 * Mobile hits masthead (`requestMobileStoreFeed`); desktop hits homepage feed (`requestDesktopFeed`).
 * Empty identity fields (pincode / email / fnpId) are omitted from the payload.
 *
 * @param {Function} dispatch - Redux dispatch.
 * @param {Object} [args]
 * @param {boolean} [args.isMobile] - Whether device is mobile (msite).
 * @param {string} [args.pincode] - Optional pincode; omit / empty to refresh without location.
 * @param {string} [args.storeId] - Active masthead store id (mobile).
 * @param {string} [args.storeName] - Active masthead store name (mobile).
 * @returns {void}
 */
export const dispatchHomeFeedRefresh = (dispatch, { isMobile = false, pincode, storeId, storeName } = {}) => {
  if (typeof dispatch !== "function") {
    return;
  }

  const email = CookieUtil.getCookie("faul") || "";
  const fnpId = CookieUtil.getCookie("ab_user_id") || "";
  const feedPayload = {
    ...(pincode ? { pincode } : {}),
    ...(email ? { email } : {}),
    ...(fnpId ? { fnpId } : {}),
  };

  if (isMobile) {
    dispatch(
      requestMobileStoreFeed({
        ...feedPayload,
        storeId,
        storeName,
        forceCall: true,
      }),
    );
    return;
  }

  dispatch(requestDesktopFeed(feedPayload));
};
